import { ChangeDetectionStrategy, Component, TemplateRef, computed, inject, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

import { AUTH_MANAGER } from '@asset-solutions/customer-portal/auth/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';

@Component({
  selector: 'cp-user-menu',
  imports: [
    FormsModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatIcon,
    MatDialogModule,
    MatButton,
    MatRadioButton,
    MatRadioGroup
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuComponent {
  public readonly colorSchemeDialog = viewChild.required<TemplateRef<any>>('colorSchemeDialog');
  public readonly contactUs = output<void>();
  public readonly logout = output<void>();
  public readonly passwordReset = output<void>();
  private readonly authManager = inject(AUTH_MANAGER);
  private readonly dialog = inject(MatDialog);
  protected readonly colorMode = inject(ColorMode);

  protected initials = computed(() => {
    const names = this.authManager.currentUser()?.displayName?.split(' ');
    return names ? `${names[0][0]}${names[1]?.[0] || ''}` : '';
  });
  protected isCrstUser = this.authManager.isCrstUser;

  protected opnDialog(): void {
    this.dialog.open(this.colorSchemeDialog());
  }
}
